import { StepState } from '../enums/enums';

export interface Step {
  title: string;
  state: StepState;
  route?: string;
}

export class ModuleSteps {
  steps: Step[];
  actives: Step[];

  constructor(value: Step[]) {
    this.steps = value;
    this.actives = value;
  }

  complete(index: number) {
    this.actives = this.actives.map((step, i) => {
      step.state = i <= index ? StepState.Completed : StepState.Normal;
      return step;
    });
    return this.actives;
  }

  active(index: number): Step[] {
    this.actives = this.actives.map((step, i) => {
      step.state =
        i < index ? StepState.Completed : index === i ? StepState.Active : StepState.Normal;
      return step;
    });
    return this.actives;
  }

  error(index: number): Step[] {
    this.actives = this.actives.map((step, i) => {
      step.state =
        i < index ? StepState.Completed : index === i ? StepState.Error : StepState.Normal;
      return step;
    });
    return this.actives;
  }

  stateOnActive(newState: StepState): Step[] {
    this.actives = this.actives.map((step) => {
      step.state = step.state === StepState.Active ? newState : step.state;
      return step;
    });
    return this.actives;
  }

  deactivate(from: number, quantity: number): Step[] {
    this.actives = [...this.steps];
    this.actives.splice(from, quantity);
    return this.actives;
  }

  removeStep(index: number): Step[] {
    this.actives = [...this.steps].filter((_, i) => i !== index);
    return this.actives;
  }
}
